import { Lock, Ban, CalendarClock } from "lucide-react";

const fmtOpens = (iso) => {
  const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso || "");
  // Naive values are already tenant-local (Berlin) — format them without shifting.
  const d = new Date(hasTz ? iso : `${iso}Z`);
  return isNaN(d) ? "" : d.toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: hasTz ? "Europe/Berlin" : "UTC" });
};

// closed beats sold-out beats upcoming.
export function shopStatus(item) {
  const state = item.shop_status || (item.sales_state === "closed" ? "closed" : item.sold_out ? "sold_out" : item.sales_state);
  if (state === "closed") return { kind: "closed", label: "Bookings Closed", icon: Lock, blocked: true };
  if (state === "sold_out") return { kind: "sold_out", label: "Sold Out", icon: Ban, blocked: true };
  if (state === "upcoming") {
    const at = item.opens_at || item.sales_start;
    return { kind: "upcoming", label: at ? `Sale opens ${fmtOpens(at)}` : "Sale opens soon", icon: CalendarClock, blocked: false };
  }
  return null;
}

export const FADE_IMG = "grayscale-[70%] opacity-75";
export const FADE_BODY = "opacity-60";

const TONE = {
  closed: "bg-slate-900/55 text-white",
  sold_out: "bg-white/60 text-rose-700",
  upcoming: "bg-white/70 text-slate-700",
};

export function StatusBand({ status, testid }) {
  if (!status) return null;
  const Icon = status.icon;
  return (
    <div className={`absolute inset-x-0 bottom-0 z-10 backdrop-blur-md border-t border-white/30 px-3 py-2.5 flex items-center justify-center gap-2 ${TONE[status.kind]}`} data-testid={testid} data-status={status.kind}>
      <Icon className="w-4 h-4" strokeWidth={2.25} />
      <span className={`text-sm font-bold ${status.kind === "upcoming" ? "" : "uppercase tracking-[0.18em]"}`}>{status.label}</span>
    </div>
  );
}

export function StatusPill({ status, testid }) {
  return (
    <div className="flex justify-end mt-auto pt-3">
      <span className="px-4 py-1.5 rounded-full bg-slate-100 text-slate-500 text-xs font-semibold cursor-not-allowed" data-testid={testid}>{status.label}</span>
    </div>
  );
}
